<template>
  <div>
    <div class="mb-4">
      <b-card>
        <h6 class="mb-4 font-weight-bold">Filter</h6>
        <b-row align-v="center">
          <b-col>
            <b-form-group
              label="Year(s)"
            >
              <custom-select
                v-model="selectedYear"
                :options="yearFilter.filters"
                placeholder="Select year"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <div class="button-project mt-2 d-flex justify-content-end">
              <b-button
                class="reset mr-3"
                variant="outline-warning"
                @click="resetFilter"
              >
                Reset Filter
              </b-button>
              <b-button
                class="next"
                variant="warning"
                @click="applyFilter"
              >
              Apply Filter
            </b-button>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </div>
    <div>
      <b-card>
        <h5 class="mb-4 mt-2 font-weight-bold">Graphic Statistic Attendance Employee/Year</h5>
        <bar
          :chart-options="chartOptions"
          :chart-data="chartData"
          style="margin-right: 30px;"
        />
      </b-card>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { Bar } from 'vue-chartjs'
import ChartJSPluginDatalabels from 'chartjs-plugin-datalabels'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ChartJSPluginDatalabels
)

export default {
  name: 'App',
  components: {
    Bar
  },
  data() {
    return {
      selectedYear: new Date().getFullYear(),
      yearFilter: {
        show: true,
        filters: []
      },
      attendanceDataPerYear: [],
      monthsInNumber: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
      attendanceType: [],
      dataSetJanuary: [],
      dataSetFebruary: [],
      dataSetMarch: [],
      dataSetApril: [],
      dataSetMay: [],
      dataSetJune: [],
      dataSetJuly: [],
      dataSetAugust: [],
      dataSetSeptember: [],
      dataSetOctober: [],
      dataSetNovember: [],
      dataSetDecember: [],
      chartData: {
        labels: [],
        datasets: [
          {
            label: 'January',
            backgroundColor: '#f9bf59',
            data: []
          },
          {
            label: 'February',
            backgroundColor: '#f47979',
            data: []
          },
          {
            label: 'March',
            backgroundColor: '#69a4e4',
            data: []
          },
          {
            label: 'April',
            backgroundColor: '#b4d435',
            data: []
          },
          {
            label: 'May',
            backgroundColor: '#e3c75f',
            data: []
          },
          {
            label: 'June',
            backgroundColor: '#7b77b9',
            data: []
          },
          {
            label: 'July',
            backgroundColor: '#d365ba',
            data: []
          },
          {
            label: 'August',
            backgroundColor: '#53c7c7',
            data: []
          },
          {
            label: 'September',
            backgroundColor: '#ce495f',
            data: []
          },
          {
            label: 'October',
            backgroundColor: '#a6d854',
            data: []
          },
          {
            label: 'November',
            backgroundColor: '#d1833b',
            data: []
          },
          {
            label: 'December',
            backgroundColor: '#5e83ba',
            data: []
          }
        ]
      },
      chartOptions: {
        responsive: true,
        tooltips: {
          mode: 'index',
          intersect: false
        },
        scales: {
          x: {
            type: 'category'
            // stacked: true
          },
          y: {
            title: {
              display: true,
              text: 'Value'
              // stacked: true
            },
            ticks: {
              beginAtZero: true,
              stepSize: 2
            }
          }
        },
        plugins: {
          legend: {
            display: true,
            position: 'bottom'
          },
          title: {
            display: true,
            text: 'Annual Attendance',
            position: 'top'
          },
          aspectRatio: 5 / 3,
          datalabels: {
            anchor: 'end',
            align: 'end',
            formatter: (value, ctx) => {
              return Math.round(value)
            },
            color: '#000000',
            font: {
              weight: 'bold'
            }
          }
        }
      }
    }
  },
  created() {
    const startYear = 2021
    const currentDate = new Date()
    for (let i = startYear; i <= currentDate.getFullYear(); i++) {
      this.yearFilter.filters.push(i)
    }
    this.getAttendanceType()
    this.getAttendancePerYear()
  },
  watch: {
    attendanceDataPerYear: {
      handler() {
        this.dataSetJanuary = this.countAttendanceTypePerMonth('01')
        this.dataSetFebruary = this.countAttendanceTypePerMonth('02')
        this.dataSetMarch = this.countAttendanceTypePerMonth('03')
        this.dataSetApril = this.countAttendanceTypePerMonth('04')
        this.dataSetMay = this.countAttendanceTypePerMonth('05')
        this.dataSetJune = this.countAttendanceTypePerMonth('06')
        this.dataSetJuly = this.countAttendanceTypePerMonth('07')
        this.dataSetAugust = this.countAttendanceTypePerMonth('08')
        this.dataSetSeptember = this.countAttendanceTypePerMonth('09')
        this.dataSetOctober = this.countAttendanceTypePerMonth('10')
        this.dataSetNovember = this.countAttendanceTypePerMonth('11')
        this.dataSetDecember = this.countAttendanceTypePerMonth('12')
        this.chartData.datasets.forEach((data, index) => {
          if (index === 0) {
            data.data = this.dataSetJanuary
          } else if (index === 1) {
            data.data = this.dataSetFebruary
          } else if (index === 2) {
            data.data = this.dataSetMarch
          } else if (index === 3) {
            data.data = this.dataSetApril
          } else if (index === 4) {
            data.data = this.dataSetMay
          } else if (index === 5) {
            data.data = this.dataSetJune
          } else if (index === 6) {
            data.data = this.dataSetJuly
          } else if (index === 7) {
            data.data = this.dataSetAugust
          } else if (index === 8) {
            data.data = this.dataSetSeptember
          } else if (index === 9) {
            data.data = this.dataSetOctober
          } else if (index === 10) {
            data.data = this.dataSetNovember
          } else if (index === 11) {
            data.data = this.dataSetDecember
          }
        })
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async getAttendancePerYear() {
      try {
        const { data } = await api.presence.listDetail({
          page: 1,
          pageSize: 100000,
          Filters: `attendanceDate>=${this.selectedYear}-01-01, attendanceDate<=${this.selectedYear}-12-31`
        })
        this.attendanceDataPerYear = []
        data.data.forEach(item => {
          this.attendanceDataPerYear.push({
            id: item.id,
            attendanceId: item.attendanceId,
            attendanceDate: this.formatedDate(item.attendanceDate),
            month: this.extractStringDateToMonthNumber(this.formatedDate(item.attendanceDate)),
            attendanceTypeId: item.attendanceTypeId
          })
        })
      } catch (error) {
        console.log(error)
      }
    },
    async getAttendanceType() {
      try {
        const { data } = await api.presence.getTypeAttendance()
        this.attendanceType = []
        this.attendanceType = data.data
        data.data.forEach(type => {
          if (type.name !== 'Hadir') {
            if (type.name === 'Izin 1/4 Hari') {
              this.chartData.labels.push('QI')
            } else if (type.name === 'Izin 1/2 Hari') {
              this.chartData.labels.push('HDI')
            } else if (type.name === 'Izin') {
              this.chartData.labels.push('I')
            } else if (type.name === 'Alfa 1/4 Hari') {
              this.chartData.labels.push('QA')
            } else if (type.name === 'Alfa 1/2 Hari') {
              this.chartData.labels.push('HDA')
            } else if (type.name === 'Alfa') {
              this.chartData.labels.push('A')
            } else if (type.name === 'Sakit 1/4 Hari') {
              this.chartData.labels.push('QS')
            } else if (type.name === 'Sakit 1/2 Hari') {
              this.chartData.labels.push('HDS')
            } else if (type.name === 'Sakit') {
              this.chartData.labels.push('S')
            } else if (type.name === 'Cuti') {
              this.chartData.labels.push('C')
            } else if (type.name === 'Libur') {
              this.chartData.labels.push('L')
            }
          }
        })
      } catch (error) {
        console.log(error)
      }
    },
    countAttendanceTypePerMonth(month) {
      const attendanceCounts = {
        HDI: 0,
        QI: 0,
        HDS: 0,
        HDA: 0,
        QA: 0,
        QS: 0,
        L: 0,
        I: 0,
        S: 0,
        A: 0,
        C: 0
      }
      this.attendanceDataPerYear.forEach(item => {
        if (item.month === month) {
          this.attendanceType.forEach(type => {
            if (item.attendanceTypeId === type.id) {
              if (type.name === 'Izin 1/4 Hari') {
                attendanceCounts.QI++
              } else if (type.name === 'Izin 1/2 Hari') {
                attendanceCounts.HDI++
              } else if (type.name === 'Izin') {
                attendanceCounts.I++
              } else if (type.name === 'Alfa 1/4 Hari') {
                attendanceCounts.QA++
              } else if (type.name === 'Alfa 1/2 Hari') {
                attendanceCounts.HDA++
              } else if (type.name === 'Alfa') {
                attendanceCounts.A++
              } else if (type.name === 'Sakit 1/4 Hari') {
                attendanceCounts.QS++
              } else if (type.name === 'Sakit 1/2 Hari') {
                attendanceCounts.HDS++
              } else if (type.name === 'Sakit') {
                attendanceCounts.S++
              } else if (type.name === 'Cuti') {
                attendanceCounts.C++
              } else if (type.name === 'Libur') {
                attendanceCounts.L++
              }
            }
          })
        }
      })

      for (const type in attendanceCounts) {
        if (attendanceCounts[type] === 0) {
          attendanceCounts[type] = null
        }
      }

      return Object.values(attendanceCounts)
    },
    seperateDateAndTime(data) {
      return data.split(' ')[0]
    },
    extractStringDateToMonthNumber(date) {
      const newFormatDate = new Date(date)
      const month = String(newFormatDate.getMonth() + 1).padStart(2, '0')
      return month
    },
    formatedDate(date) {
      const newFormatDate = new Date(date)
      const year = newFormatDate.getFullYear()
      const month = String(newFormatDate.getMonth() + 1).padStart(2, '0')
      const day = String(newFormatDate.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    applyFilter() {
      this.chartData.datasets.forEach(data => {
        data.data = []
      })
      this.getAttendancePerYear()
    },
    resetFilter() {
      this.selectedYear = new Date().getFullYear()
      this.chartData.datasets.forEach(data => {
        data.data = []
      })
      this.getAttendancePerYear()
    }
  }
}
</script>

<style lang="scss" scoped>
*{
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.help-button{
  border: 1px solid rgb(126, 125, 125);
}
